import axios from 'axios';
import { clearAllCookies } from '../utils/cookies';
import { auth } from '../services/firebase';
import { signOut } from 'firebase/auth';
import { datadogRum } from '@datadog/browser-rum';
import type { UpdateLastSignedInResponse } from '../types/security';

export const getUserDataByUID = async (uid: string, accessToken : string, agencyId ?: string, providerId ?: string) => {
    let headers : any = {
        'Authorization': `Bearer ${accessToken}`
    };
    if(agencyId) {
        headers['agency-id'] = agencyId;
    }
    if(providerId) {
        headers['provider-id'] = providerId;
    }
    const response = await axios.get(`${import.meta.env.VITE_AUTH_API_URL}/api/v1/auth/users/${uid}`, {
        headers: headers
    })
    return response.data
}

export const getUserCompaniesByUID = async (uid: string, orgType: string, orgId: string, accessToken: string) => {
    const orgKey = orgType === 'agency' ? 'agency-id' : 'provider-id';
    const response = await axios.get(`${import.meta.env.VITE_AUTH_API_URL}/api/v1/auth/users/${uid}/companies`, {
        headers: {
            'Authorization': `Bearer ${accessToken}`,
            [orgKey]: orgId
        }
    });
    return response.data;
};

export const updateUserSSOStatus = (accessToken: string, id : string, status: boolean) => {
    return axios.put(`${import.meta.env.VITE_AUTH_API_URL}/api/v1/auth/users/${id}/sso`, { status },{
        headers: {
            Authorization: 'Bearer ' + accessToken
        }
    });
}

export const userSignOut = () => {
    clearAllCookies()
    sessionStorage.clear();
    localStorage.clear();
    signOut(auth)
    datadogRum.clearUser();
    datadogRum.stopSessionReplayRecording();
}

export const updateLastRequestTime = async (accessToken: string) => {
    const response = await axios.put(`${import.meta.env.VITE_FIREBASE_API_URL}/auth/update-user-last-request-time`, {}, {
        headers: {
            Authorization: 'Bearer ' + accessToken
        }
    });

    return response.data;
}

export const recordLastSignedIn = async (
    uid: string,
    firebaseToken: string,
    fingerprint: string
): Promise<UpdateLastSignedInResponse> => {
    const response = await axios.put<UpdateLastSignedInResponse>(
        `${import.meta.env.VITE_AUTH_API_URL}/api/v1/auth/users/${uid}/lastSignedIn`,
        { fingerprint },
        { headers: { Authorization: `Bearer ${firebaseToken}` } }
    );
    return response.data;
}